import { Component, OnInit } from '@angular/core';
import { ANDROID_APP_LINK, IOS_APP_LINK, SUPPORT_EMAIL } from 'src/app/constants/emailAndLinks';
import { IMAGES } from 'src/app/constants/imagePath';
import { ROUTES } from 'src/app/constants/Routes';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {
  Routes = ROUTES;
  Images = IMAGES;
  SupportEmail = SUPPORT_EMAIL;
  ANDROID_APP_LINK = ANDROID_APP_LINK;
  IOS_APP_LINK = IOS_APP_LINK;
  currentYear = new Date().getFullYear();
  
  constructor() { }

  ngOnInit() {
  }

}
